export default {
  nav: {
    main: 'Főoldal',
    ordersAndInvoices: 'Rendelések és Számlák',
    drafts: 'Piszkozatok',
    automation: 'Automatizálás',
    workspace: 'Munkaterület',
    templates: 'Sablonok',
    delivery: 'Kézbesítés',
    settings: 'Beállítások',
    shippingLabels: 'Szállítási címkék',
    subscriptions: 'Előfizetések',
    support: 'Támogatás',
    developer: 'Fejlesztő',
    writeReview: 'Vélemény írása',
    supportTicket: 'Támogatási jegy',
    welcomeTour: 'Üdvözlő bemutató',
    administratorConsole: 'Adminisztrátori konzol',
    logout: 'Kijelentkezés',
  },
  dashboard: {
    pageTitle: 'Rendelések és Számlák',
    pageDescription: 'Manage your orders and invoices',
    title: 'Rendelések és Számlák',
    selectedOrders: '{count} kiválasztott rendelés',
    completed: '% kész',
    processing: 'Feldolgozás folyamatban, kérjük várjon...',
    bulkDownload: 'Tömeges letöltés',
    upgradeBulkDownload: 'Frissítse csomagját a Tömeges letöltéshez',
    showFilters: 'Szűrők megjelenítése',
    hideFilters: 'Szűrők elrejtése',
    creatingInvoices: 'Számlák létrehozása, kérjük várjon...',
    bulkCreateInvoices: 'Számlák tömeges létrehozása',
    cannotCreateAutopilot: 'Nem hozhat létre manuálisan számlákat, ha a számlázási mód automatikus.',
    exportInvoices: 'Számlák vagy rendelések exportálása',
    capturePayments: 'Fizetések manuális rögzítése',
    filterOrders: 'Rendelések szűrése',
    error: 'Hoppá, valami hiba történt...',
    close: 'Bezárás',
    chooseDate: 'Válasszon dátumot',
    chooseIssueDate: 'Válasszon kiállítási dátumot a kiválasztott számlákhoz',
    cancel: 'Mégse',
    createInvoices: 'Számlák létrehozása',
    storno: 'Sztornó',
    bulkOrderCapture: 'Tömeges rendelés rögzítés',
  },
  search: {
    createdBetween: 'Létrehozva között',
    modifiedBetween: 'Módosítva között',
    orderNumber: 'Rendelés #',
    invoiceNumber: 'Számla #',
    refundNumber: 'Visszatérítés #',
    customer: 'Vásárló',
    payment: 'Fizetés',
    any: 'Bármely',
    authorized: 'Engedélyezett',
    pending: 'Függőben',
    paid: 'Fizetve',
    partiallyPaid: 'Részben fizetve',
    refunded: 'Visszatérítve',
    voided: 'Érvénytelenítve',
    partiallyRefunded: 'Részben visszatérítve',
    unpaid: 'Fizetetlen',
    fulfillment: 'Teljesítés',
    fulfilled: 'Teljesítve',
    partial: 'Részleges',
    unfulfilled: 'Nem teljesített',
    loading: 'Rendelések betöltése...',
    search: 'Keresés',
  },
  orderList: {
    noCustomer: 'Nincs vásárló',
    downloadOrder: 'Rendelés letöltése',
    deleteWarning: 'Fontos! Ez törli az összes számlát és visszatérítést, amelyek a következő dátum után lettek létrehozva:',
    includingInvoice: 'beleértve a kiválasztott számla #',
    pressOk: 'Nyomja meg az OK-t a folytatáshoz vagy a Mégse-t a megszakításhoz.',
    cannotCreateAutopilot: 'Nem hozhat létre manuálisan számlákat, ha a számlázási mód automatikus.',
    createInvoice: 'Számla létrehozása ehhez a rendeléshez',
    create: 'Létrehozás',
    addCreditNote: 'Jóváírás hozzáadása',
    createStorno: 'Sztornó számla létrehozása',
    refund: 'Visszatérítés',
    downloadInvoice: 'Számla letöltése',
    download: 'Letöltés',
    default: 'Alapértelmezett',
    downloadStorno: 'Sztornó/jóváírás letöltése',
    fulfillOrder: 'Rendelés teljesítése',
    orderNum: 'Rendelés #',
    locPrefix: 'Hely előtag',
    invoiceNum: 'Számla #',
    refundNum: 'Visszatérítés #',
    customerCol: 'Vásárló',
    orderCreatedDate: 'Rendelés létrehozásának dátuma',
    orderModifiedDate: 'Rendelés módosításának dátuma',
    delivered: 'Kézbesítve',
    paymentStatus: 'Fizetési állapot',
    fulfillmentStatus: 'Teljesítési állapot',
    totalOutstanding: 'Fennálló összeg',
    originalPrice: 'Eredeti ár',
    noOrders: 'Az üzletben nincsenek rendelések a kiválasztott állapothoz.',
    cannotCreateNoOrders: 'Nem hozhat létre számlákat, ha nincsenek rendelések.',
    createOrdersFirst: 'Kérjük, hozzon létre legalább egy rendelést, és próbálja újra.',
    createOrders: 'Rendelések létrehozása',
    loadingOrders: 'Betöltés...',
    paidManual: 'Fizetve - Manuális',
    paid: 'Fizetve',
    refunded: 'Visszatérítve',
    pending: 'Függőben',
    partiallyPaid: 'Részben fizetve',
    partiallyRefunded: 'Részben visszatérítve',
    fulfilled: 'Teljesítve',
    unfulfilled: 'Nem teljesített',
    deliveryPending: 'Függőben',
    deliverNow: 'Kézbesítés most',
    deliveryPartial: 'Részleges',
    notDelivered: 'Nem kézbesítve',
    deliverAgain: 'Újra kézbesítés',
    deliveryDetails: 'Kézbesítési részletek',
    deliveryFailed: 'Kézbesítés sikertelen',
    sent: 'Elküldve',
    failed: 'Sikertelen',
    toLabel: 'Címzett',
    folderLabel: 'Mappa',
    open: 'Nyitott',
    invoice: 'Számla',
    creditNote: 'Jóváírás',
    stornoLabel: 'Sztornó',
    unknown: 'Ismeretlen',
    googleDrive: 'Google Drive',
    clientsTablet: 'Ügyfél tablet',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Visszaállítás erre a dátumra',
    add: 'Hozzáadás',
    close: 'Bezárás',
  },
  downloadDialog: {
    downloadType: '{type} letöltése...',
    selectTemplate: 'Válasszon egy sablont a galériából rendelések, számlák, sztornó számlák vagy jóváírások exportálásához.',
    getMoreTemplates: 'További sablonok',
    createNewTemplate: 'Új sablon létrehozása',
    allCreatedBetween: 'Összes létrehozott {type} között',
    selectedType: 'Kiválasztott {type}',
    and: 'és',
    status: 'Állapot',
    any: 'Bármely',
    open: 'Nyitott',
    closed: 'Lezárt',
    cancelled: 'Törölve',
    paymentStatus: 'Fizetési állapot',
    fulfillmentStatus: 'Teljesítési állapot',
    fulfilled: 'Teljesítve',
    partial: 'Részleges',
    unfulfilled: 'Nem teljesített',
    authorized: 'Engedélyezett',
    pending: 'Függőben',
    paid: 'Fizetve',
    partiallyPaid: 'Részben fizetve',
    refunded: 'Visszatérítve',
    voided: 'Érvénytelenítve',
    partiallyRefunded: 'Részben visszatérítve',
    unpaid: 'Fizetetlen',
    format: 'Formátum',
    forLocation: 'Helyszín',
    advancedOptions: 'Speciális beállítások',
    exportHSCodes: 'Készlet HS-kódok exportálása (lassabb)',
    noteChrome: 'Megjegyzés: Az optimális letöltéshez a Chrome böngésző ajánlott és a hirdetésblokkoló kikapcsolása.',
    downloadIndividually: 'Letöltés egyenként',
    downloadGrouped: 'Letöltés csoportosítva',
  },
  templates: {
    pageTitle: 'Sablonok',
    pageDescription: 'Customize your invoice templates',
    title: 'Sablonok',
    installTranslated: 'Lefordított sablon telepítése',
    installTranslatedDesc: 'Válasszon másik nyelvet erre a gombra kattintva.',
    createNew: 'Új sablon létrehozása szükség esetén',
    createNewDesc: 'Kattintson erre a gombra új sablon létrehozásához, ha szükséges.',
    customize: 'Sablonok testreszabása',
    customizeDesc: 'Kattintson az alapértelmezett sablonra a testreszabáshoz. Módosíthatja a logót, a színeket, és haladó felhasználók számára a mögöttes kódot.',
    defaultTemplate: 'Számla, Sztornó és Jóváírás (Alapértelmezett)',
    logo: 'Logó',
    colorPalette: 'Színpaletta',
    getColorPalettes: 'Színpaletták beszerzése',
    paperSize: 'Papírméret',
    format: 'Formátum',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Tájolás',
    landscape: 'Fekvő',
    portrait: 'Álló',
    margin: 'Margó (cm)',
    unsavedChanges: 'Mentetlen módosítások',
    discard: 'Elvetés',
    save: 'Mentés',
  },
  labels: {
    pageTitle: 'Szállítási címkék',
    pageDescription: 'Create and manage shipping labels',
    title: 'Szállítási címkék',
    glsRequiresPro: 'A GLS szállítási címkék Kelet-Közép-Európához Professional csomagot igényelnek.',
    upgradeDesc: 'Frissítsen Professional csomagra szállítási címkék létrehozásához és kezeléséhez.',
    upgradePlan: 'Csomag frissítése',
    eeuGls: 'EEU GLS',
    enabled: 'Engedélyezve',
    country: 'Ország',
    hungary: 'Magyarország',
    slovakia: 'Szlovákia',
    czech: 'Csehország',
    romania: 'Románia',
    slovenia: 'Szlovénia',
    croatia: 'Horvátország',
    senderId: 'Feladó azonosító',
    username: 'Felhasználónév',
    password: 'Jelszó',
    name: 'Név',
    city: 'Város',
    address: 'Cím',
    zipCode: 'Irányítószám',
    contactPerson: 'Kapcsolattartó',
    phone: 'Telefon',
    email: 'E-mail',
    glsServices: 'GLS szolgáltatások',
    expressService: 'Expressz szolgáltatás',
    exchangeService: 'Csere szolgáltatás',
    smsService: 'SMS szolgáltatás',
    smsText: 'SMS szöveg',
    preAdviceService: 'Előzetes értesítés szolgáltatás',
    unsavedChanges: 'Mentetlen módosítások',
    discard: 'Elvetés',
    save: 'Mentés',
  },
  billing: {
    pageTitle: 'Számlázás',
    pageDescription: 'Manage your subscription and billing',
    title: 'Számlázás',
    subscriptionFor: 'Előfizetési csomag az üzlethez',
    currentlySubscribed: 'Jelenleg a következő csomagra van előfizetve:',
    plan: 'csomag',
    cancelSubscription: 'Előfizetés lemondása',
    upgradePlan: 'Csomag frissítése',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / hó',
    upgrade: 'Frissítés',
    includesAllStarter: 'Tartalmazza az összes Starter funkciót, valamint:',
    proFeature1: 'Globális megfelelőségi csomag: Helyszín alapú előtagok és egyéni sorszámozás',
    proFeature2: 'Intelligens lokalizáció: Automatikusan fordított e-mailek és lokalizált PDF mellékletek',
    proFeature3: 'Teljes B2B dokumentum életciklus: Proformák, B2B árajánlatok és Jóváírások',
    proFeature4: 'B2B könyvelési szinkron: 3 tizedes jegyű egységár és többvalutás megjelenítés',
    proFeature5: 'Automatikus biztonsági mentés: Számlák automatikus másolása biztonságos FTP-re vagy Google Drive-ra',
    proFeature6: 'Shopify Flow: Számla generálás, kézbesítés és sztornó automatizálása Flow triggerekkel és akciókkal',
    proFeature7: 'Fejlett AI logika: Használja az eszközön futó AI-t összetett feltételes elrendezési szabályokhoz',
    proFeature8: 'UBL XML és ZUGFeRD / Factur-X exportok (Európai e-számlázási megfelelőség)',
    proFeature9: 'EPC QR kódok azonnali mobil POS fizetésekhez',
    proFeature10: 'GLS szállítási címkék Kelet-Közép-Európához',
    proFeature11: '7 éves adómegőrzési megfelelőség',
    currentlyUsing: 'Jelenleg a következő csomagot használja:',
    free: 'ingyenes',
    subscriptionPlan: 'előfizetési csomag.',
    monthlyUsage: 'Havi használat',
    monthlyGenerated: '{count} / 50 számla ebben a hónapban',
    monthlyLimitReached: 'Havi limit elérve. Frissítsen Starter csomagra korlátlan számlákhoz.',
    freePlan: 'Ingyenes csomag',
    freeToInstall: 'Ingyenesen telepíthető',
    freeFeature1: 'Legfeljebb 50 számla/rendelés havonta',
    freeFeature2: 'Hozzáférés mind a 31+ előre definiált sablonhoz',
    freeFeature3: 'Alap AI Copilot',
    freeFeature4: 'Standard PDF letöltés és nyomtatás',
    freeFeature5: 'Standard dokumentumcsomag (Számlák, Szállítólevelek, Nyugták)',
    freeFeature6: '3 hónapos biztonságos számlamegőrzés',
    starterPlan: 'Starter csomag',
    starterPrice: '$9.99 / hó',
    starterPricePerInvoice: '+ 3¢ létrehozott számlánként',
    subscribe: 'Feliratkozás',
    starterFeature1: 'Korlátlan számlák és rendelések',
    starterFeature2: 'Automatizált PDF kézbesítés e-mailben',
    starterFeature3: 'Teljes hozzáférés a hibrid szerkesztőhöz és AI Copilothoz',
    starterFeature4: 'Shopify POS és vonalkód integráció',
    starterFeature5: 'Shopify Flow: Triggerek és akciók számla automatizáláshoz',
    starterFeature6: 'UBL XML / PEPPOL és ZUGFeRD / Factur-X exportok (E-számlázási megfelelőség)',
    starterFeature7: '1 éves biztonságos számlamegőrzés',
    proTaxOverrides: 'Egyéni adó felülírások: ÁFA / GST termékenként és cikkszám szintű adókulcsok',
    unsavedChanges: 'Mentetlen módosítások',
    discard: 'Elvetés',
    save: 'Mentés',
  },
  autopilot: {
    pageTitle: 'Automatizálás',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatizálás',
    autoCreate: 'Számlák automatikus létrehozása',
    disabled: 'Letiltva (Manuális)',
    whenCreated: 'Amikor rendelések létrejönnek',
    whenFulfilled: 'Amikor rendelések teljesítve lesznek',
    whenPaid: 'Amikor rendelések ki lesznek fizetve',
    autoCreateDesc: 'A számlák a rendelések létrehozásának, teljesítésének vagy kifizetésének dátumával jönnek létre.',
    autoStorno: 'Számlák automatikus sztornózása',
    whenCancelled: 'Amikor rendelések törölve vagy visszatérítve lesznek',
    autoStornoDesc: 'Sztornó számlák a rendelések érvénytelenítésének/törlésének vagy visszatérítések létrehozásának dátumával jönnek létre.',
    cannotAutoFree: 'Számlák automatikus létrehozása nem érhető el az ingyenes csomaggal.',
    upgradePlan: 'Csomag frissítése',
    unsavedChanges: 'Mentetlen módosítások',
    discard: 'Elvetés',
    save: 'Mentés',
  },
  delivery: {
    pageTitle: 'Kézbesítés',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Kézbesítés',
    settings: 'Beállítások',
    useOrderNumbers: 'Rendelésszámok használata fájlnevekhez',
    sendIfCountry: 'Küldés, ha a számlázási cím országa',
    countryCodesHint: 'Sorolja fel az összes országkódot pontosvesszővel elválasztva.',
    sendForTags: 'Küldés olyan vásárlóknak, akiknek van a felsorolt címkék egyike',
    tagsHint: 'Sorolja fel az összes címkét pontosvesszővel elválasztva.',
    emailDelivery: 'E-mail kézbesítés',
    sendAsPdf: 'Számlák küldése PDF mellékletként a vásárlóknak',
    autoSend: 'Automatikus küldés számla létrehozásakor',
    subject: 'Tárgy',
    body: 'Szövegtörzs',
    xmlAttachments: 'XML mellékletek',
    attachUbl: 'UBL/PEPPOL XML csatolása (E-Factura)',
    attachZugferd: 'ZUGFeRD / Factur-X XML csatolása',
    sendTestEmail: 'Teszt e-mail küldése',
    sending: 'Küldés...',
    customSmtp: 'Egyéni SMTP szerver',
    customSmtpDesc: 'Használja saját levelezőszerverét az alapértelmezett helyett',
    enableSmtp: 'Egyéni SMTP engedélyezése',
    smtpHost: 'SMTP kiszolgáló',
    port: 'Port',
    useSsl: 'SSL/TLS használata',
    username: 'Felhasználónév',
    password: 'Jelszó',
    fromEmail: 'Feladó e-mail',
    fromName: 'Feladó név',
    shopifyLiquid: 'Shopify Liquid sablon',
    pasteInto: 'Illessze be a következőbe:',
    orderConfirmation: 'rendelés visszaigazoló sablon',
    toAddLink: 'a letöltési link hozzáadásához.',
    downloadInvoice: 'Számla letöltése',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Kérések küldése a ClientsTablet felé számlák létrehozásakor',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'PDF számlák küldése vámokmányként a ShippyPro-nak nem EU-s országok számára',
    ftpBackup: 'FTP / SFTP biztonsági mentés',
    ftpDesc: 'Számlák automatikus másolása a szerverére',
    enableFtp: 'Automatikus FTP biztonsági mentés engedélyezése',
    host: 'Kiszolgáló',
    useSftp: 'SFTP használata (biztonságos)',
    destinationFolder: 'Célmappa',
    xmlFiles: 'XML fájlok',
    includeUbl: 'UBL/PEPPOL XML mellékelése (E-Factura)',
    includeZugferd: 'ZUGFeRD / Factur-X XML mellékelése',
    testConnection: 'Kapcsolat tesztelése',
    testing: 'Tesztelés...',
    pro: 'PRO',
    upgradeFtp: 'Frissítsen Professional csomagra a számlák automatikus másolásához FTP/SFTP szerverre.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Számlák automatikus szinkronizálása a Drive-ra',
    connected: 'Kapcsolódva',
    disconnect: 'Leválasztás',
    notWorking: 'Nem működik? Menjen a',
    googlePermissions: 'Google Engedélyek',
    removeThenReconnect: 'oldalra, távolítsa el az Invoice Browse-t, majd csatlakozzon újra.',
    connectGoogleDrive: 'Google Drive csatlakoztatása',
    upgradeGoogleDrive: 'Frissítsen Professional csomagra a számlák automatikus szinkronizálásához Google Drive-ra.',
    unsavedChanges: 'Mentetlen módosítások',
    discard: 'Elvetés',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Mentés',
  },
  bookkeeping: {
    pageTitle: 'Beállítások',
    pageDescription: 'Configure your invoice settings',
    title: 'Beállítások',
    owner: 'Tulajdonos',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Külön számlaszámozás fenntartása minden rendelési helyszínhez',
    keepDifferentNumberingDisabled: 'A külön számlaszámozás minden rendelési helyszínhez nem érhető el az Ön csomagjával.',
    locationEmailDesc: 'Ez lehetővé teszi e-mailek és számlák küldését a rendelési helyszín alapján fordítva: készlethelyszín, szállítási vagy számlázási cím',
    upgradePlan: 'Csomag frissítése',
    matchingCriteria: 'Egyeztetési feltételek',
    locationId: 'Helyszín azonosító',
    shippingCountryCode: 'Szállítási cím országkód',
    billingCountryCode: 'Számlázási cím országkód',
    matchLocationDesc: 'Helyszín egyeztetése rendelési helyszín azonosító, szállítási vagy számlázási cím országkód alapján.',
    companyInfo: 'Céginformáció',
    name: 'Név',
    website: 'Weboldal',
    registrationNumber: 'Cégjegyzékszám',
    taxId: 'Adószám',
    addressSection: 'Cím',
    streetName: 'Utcanév',
    streetNumber: 'Házszám',
    zip: 'Irányítószám',
    city: 'Város',
    region: 'Régió',
    country: 'Ország',
    bankingInfo: 'Banki adatok',
    bankName: 'Bank neve',
    swift: 'Swift',
    currency: 'Pénznem',
    iban: 'IBAN',
    invoicing: 'Számlázás',
    decimalPlaces: 'Tizedesjegyek',
    invoicesPrefix: 'Számla előtag',
    currentInvoiceNumber: 'Jelenlegi számlaszám',
    creditNotesPrefix: 'Jóváírás előtag',
    currentCreditNoteNumber: 'Jelenlegi jóváírásszám',
    lastInvoiceDate: 'Utolsó számla dátuma',
    noInvoicesYet: 'Még nem készült számla.',
    confirmReverting: 'Visszaállítás megerősítése',
    allInvoicesAfter: 'Az összes számla és azok sztornója, amelyek a következő dátum után lettek kiállítva:',
    willBeRemoved: 'törlésre kerülnek. Folytatja a rendszer visszaállítását?',
    cancel: 'Mégse',
    revert: 'Visszaállítás',
    revertDesc: 'A rendszer visszaállítása törli az összes számlát, amelyek a kiválasztott dátum után lettek létrehozva.',
    revertToDate: 'Visszaállítás erre a dátumra',
    reverting: 'Rendszer visszaállítása, kérjük várjon...',
    useOrderNumbering: 'Rendelésszámozás használata',
    showVat: 'ÁFA megjelenítése a számlákon',
    overrideTaxes: 'Adók felülírása',
    pricesIncludeTax: 'Az árak tartalmazzák az adót',
    productsTaxRate: 'Termékek adókulcsa',
    shippingTaxRate: 'Szállítás adókulcsa',
    skusSeparated: 'Cikkszámok pontosvesszővel elválasztva',
    skusTaxRate: 'Cikkszámok adókulcsa',
    useOrderDates: 'Rendelés létrehozási dátumok használata a számlákhoz',
    convertCurrency: 'Árak átváltása a vásárló fizetési pénznemére',
    unsavedChanges: 'Mentetlen módosítások',
    discard: 'Elvetés',
    save: 'Mentés',
  },
  drafts: {
    pageTitle: 'Piszkozatok',
    pageDescription: 'Manage your draft orders',
    title: 'Piszkozatok',
    download: 'Letöltés',
    newDraft: 'Új piszkozat',
    exporting: 'Exportálás {status}%...',
    accessNotGranted: 'Piszkozat rendelések hozzáférése nem engedélyezett. Kérjük',
    reLogin: 'jelentkezzen be újra',
    toGrantPermissions: 'a szükséges "Piszkozat rendelések" jogosultságok megadásához.',
    pushFailed: 'Küldés Shopify-ba sikertelen:',
    exportError: 'Exportálási hiba:',
    confirmDelete: 'Biztosan törölni szeretné ezt a piszkozatot?',
    incompleteCustomer: 'A vásárló adatai hiányosak:',
    pushWithoutCustomer: 'A piszkozat vásárlói adatok nélkül kerül a Shopify-ba. Folytatja?',
    customerNotInShopify: 'Ez a vásárló még nem létezik a Shopify-ban.',
    warnings: 'Figyelmeztetések:',
    createCustomerAndPush: 'Létrehozza a vásárlót a Shopify-ban és elküldi a piszkozat rendelést?',
    downloadTitle: 'Piszkozatok letöltése',
    cancel: 'Mégse',
  },
  draftEdit: {
    number: "Szám",
    prefix: "Előtag",

    newDraft: 'Új piszkozat',
    editDraft: 'Piszkozat szerkesztése',
    viewInShopify: 'Megtekintés Shopify-ban',
    back: 'Vissza',
    createDraft: 'Piszkozat létrehozása',
    saveChanges: 'Módosítások mentése',
    documentType: 'Dokumentum típus',
    draftOrder: 'Piszkozat rendelés',
    quote: 'Árajánlat',
    proforma: 'Proforma',
    manualInvoice: 'Manuális számla',
    currency: 'Pénznem',
    expiryDate: 'Lejárati dátum',
    status: 'Állapot',
    draft: 'Piszkozat',
    sent: 'Elküldve',
    accepted: 'Elfogadva',
    customer: 'Vásárló',
    firstName: 'Keresztnév',
    lastName: 'Vezetéknév',
    email: 'E-mail',
    phone: 'Telefon',
    company: 'Cég',
    taxId: 'Adószám',
    billingAddress: 'Számlázási cím',
    address: 'Cím',
    aptSuite: 'Emelet/Ajtó',
    city: 'Város',
    province: 'Megye',
    countryField: 'Ország',
    zip: 'Irányítószám',
    shippingAddress: 'Szállítási cím',
    sameAsBilling: 'Megegyezik a számlázási címmel',
    lineItems: 'Tételek',
    shipping: 'Szállítás',
    shippingTitle: 'Megnevezés',
    shippingPlaceholder: 'pl. Standard szállítás',
    price: 'Ár',
    note: 'Megjegyzés',
    notePlaceholder: 'Belső megjegyzés vagy üzenet a vásárlónak...',
    summary: 'Összesítés',
    subtotal: 'Részösszeg',
    discounts: 'Kedvezmények',
    tax: 'Adó',
    total: 'Összesen',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Adja meg üzlete címét',
    loginWith: 'Bejelentkezés a következővel:',
    createAccount: 'Új fiók létrehozása',
    placeholder: 'az-on-uzlet-neve',
    shopRequired: 'Az üzlet neve kötelező',
    login: 'Bejelentkezés',
    shopify: 'Shopify',
    terms: 'Felhasználási feltételek',
    privacy: 'Adatvédelmi irányelvek',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Elégedett az Invoice Browse-zal?',
    description: 'Létrehozta első számláit! Ha hasznosnak találja az alkalmazást, egy gyors értékelés a Shopify App Store-ban sokat segít nekünk.',
    reward: 'Köszönetképpen nullázzuk a havi használati számlálóját',
    leaveReview: 'Értékelés írása',
    maybeLater: 'Talán később',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Üdvözöljük az Invoice Browse-ban',
    welcomeContent: 'Hadd mutassam meg, hogyan használhatja.',
    dashboardTitle: 'Irányítópult',
    dashboardContent: 'Az itt látható képernyő a fő irányítópult. Itt megtalálja az összes rendelést, és exportálhatja őket különböző dokumentumtípusokba, például: számlák, szállítólevelek és mások.',
    automationTitle: 'Könnyítse meg az életét',
    automationContent: 'Engedélyezze az automatizálást számlák létrehozásához, amikor rendelések kifizetésre vagy visszatérítésre kerülnek.',
    templatesTitle: 'Sablonok testreszabása',
    templatesContent: 'Lépjen be ide sablonja lefordításához, testreszabásához vagy új létrehozásához.',
    deliveryTitle: 'Kézbesítés',
    deliveryContent: 'Állítsa be alkalmazásunkat, hogy automatikusan másolja a létrehozott dokumentumokat FTP-re, Google Drive-ra, vagy e-mail mellékletként.',
    settingsTitle: 'Beállítások',
    settingsContent1: 'Módosítsa a cég telefonszámát, e-mail címét és egyéb mezőket, amelyek a dokumentumokon szerepelnek.',
    settingsContent2: 'Módosítsa a dokumentumok kezdő számát vagy törölje a kiválasztott dátum után létrehozott dokumentumokat.',
    settingsContent3: 'ÁFA kulcsok felülírása szállításhoz és termékekhez',
    settingsContent4: 'Tizedesjegyek számának módosítása',
    reviewTitle: 'Vélemény írása',
    reviewContent: 'Támogassa csapatunkat egy jó értékeléssel!',
    tourTitle: 'Üdvözlő bemutató',
    tourContent: 'Hé, ezt a bemutatót innen bármikor újra megnyithatja.',
    createDocTitle: 'Első dokumentum létrehozása',
    createDocContent: 'Kattintson a Létrehozás gombra az első dokumentum elkészítéséhez.',
    docNumberTitle: 'Dokumentumszám',
    docNumberContent: 'Az első dokumentum az 1-es számot kapta. Ha más számmal szeretne kezdeni, módosíthatja a Beállításokban.',
    downloadDocTitle: 'Dokumentum letöltése',
    downloadDocContent: 'Kattintson a Letöltés legördülő menüre, és válasszon egy dokumentumsablont a rendelés PDF-ként való exportálásához.',
  },
  common: {
    save: 'Mentés',
    cancel: 'Mégse',
    close: 'Bezárás',
    discard: 'Elvetés',
    delete: 'Törlés',
    edit: 'Szerkesztés',
    create: 'Létrehozás',
    loading: 'Betöltés...',
    unsavedChanges: 'Mentetlen módosítások',
    upgradePlan: 'Csomag frissítése',
  },
  languageSelector: {
    label: 'Nyelv',
    auto: 'Automatikus felismerés',
  },
  draftList: {
    draftNum: 'Vázlat #',
    shopifyId: 'Shopify ID',
    type: 'Típus',
    customer: 'Ügyfél',
    total: 'Összesen',
    status: 'Állapot',
    delivered: 'Kézbesítve',
    date: 'Dátum',
    actions: 'Műveletek',
    noCustomer: 'Nincs ügyfél',
    noDrafts: 'Nem található vázlat vagy árajánlat.',
    loading: 'Betöltés...',
    download: 'Letöltés',
    default: 'Alapértelmezett',
    pending: 'Függőben',
    deliverNow: 'Kézbesítés most',
    deliveryDetails: 'Kézbesítési részletek',
    sent: 'Elküldve',
    failed: 'Sikertelen',
    deliverAgain: 'Újra kézbesít',
    partial: 'Részleges',
    notDelivered: 'Nem kézbesítve',
    deliveryFailed: 'Kézbesítés sikertelen',
    unknown: 'Ismeretlen',
    edit: 'Szerkesztés',
    send: 'Küldés',
    pushToShopify: 'Küldés a Shopify-nak',
    complete: 'Befejezés',
    duplicate: 'Másolás',
    delete: 'Törlés',
    quote: 'Árajánlat',
    proforma: 'Proforma',
    draftOrder: 'Vázlat rendelés',
    manualInvoice: 'Manuális számla',
  },
  draftSearch: {
    createdBtw: 'Létrehozva közt.',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Ügyfél',
    status: 'Állapot',
    type: 'Típus',
    delivery: 'Kézbesítés',
    any: 'Mind',
    draft: 'Vázlat',
    sent: 'Elküldve',
    accepted: 'Elfogadva',
    expired: 'Lejárt',
    converted: 'Konvertálva',
    cancelled: 'Visszavonva',
    quote: 'Árajánlat',
    proforma: 'Proforma',
    draftOrder: 'Vázlat rendelés',
    manualInvoice: 'Manuális számla',
    delivered: 'Kézbesítve',
    notDelivered: 'Nem kézbesítve',
    pending: 'Függőben',
    search: 'Keresés',
  },
  draftDownload: {
    title: 'Letöltés Vázlat #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Állapot',
    documentType: 'Típus',
    any: 'Mind',
    draft: 'Vázlat',
    sent: 'Elküldve',
    accepted: 'Elfogadva',
    expired: 'Lejárt',
    converted: 'Konvertálva',
    cancelled: 'Visszavonva',
    quote: 'Árajánlat',
    proforma: 'Proforma',
    draftOrder: 'Vázlat rendelés',
    manualInvoice: 'Manuális számla',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Új sablon telepítése',
    tabStyle: 'Stílus',
    tabContent: 'Tartalom',
    tabTranslations: 'Fordítások',
    tabSettings: 'Beállítások',
    tabCode: 'Kód',
    tabCopilot: 'AI Kopilóta',
    logo: 'Logó',
    colorPalette: 'Színpaletta',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/hu.js